// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__HvWon","text":"styles_text__YEqit","absoluteBox":"styles_absoluteBox__Iyn6S","ltr":"styles_ltr__Otrsk"};